module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Thin.99e0a29c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/noto-sans-jp/NotoSansCJKjp-Thin.otf
// module id = 412
// module chunks = 0